<style>
  button {
    font-size: 1.3em;
    flex: 0 0 auto;
    margin: 0.3em;
    padding: 0.1em 1em 0.1em 1em; /* top | right | bottom | left */
  }
  h1 {
    font-size: 1.3em;
    font-weight: normal;
    text-align: center;
    padding-bottom: 0.2em;
  }
  section {
    align-content: center;
    background-color: #eee;
    display: flex;
    flex-flow: column;
    flex: 0 1 auto;
    overflow-y: auto;
    padding: 0.2em;
    width: 26em;
  }
  @media screen and (max-width: 800px) {
    section {
      width: auto;
    }
  }
   .buttons {
    display: flex;
    flex-flow: column;
  }
  .pagination {
    align-items: center;
    display: flex;
    flex-flow: row;
    padding-bottom: 0.2em;
  }
  .filler-horizontal {
    flex: 1 1 auto;
  }
  .filler-vertical {
    flex: 1 1 auto;
  }
  .items {
    display: flex;
    flex-flow: column;
    overflow-y: auto;
    padding-bottom: 0.2em;
  }
  @media screen and (max-width: 550px) {
    .filler-vertical {
      flex: 0 0 auto;
    }
  }
</style>

<script>
  import { afterUpdate, onMount } from 'svelte';
  import config from '../../config';
  import { 
    bookmarks, lang,
    leaflet_layers, leaflet_map,
    panel_selected, plots, plot_page, plot_selected,
  } from '../store';
  import util from '../util';
  import BookmarkItem from './BookmarkItem.svelte';
  import LayerItem from './LayerItem.svelte';
  import PlotItem from './PlotItem.svelte';
  import ProfileItem from './ProfileItem.svelte';
  import SideButton from './SideButton.svelte';
  
  function get_plots_shown() {
    if (!$plots) {
      return [];
    }
    const plot_seqs = Object.keys($plots).sort();
    if ($plot_selected) {
      const plot_index = plot_seqs.indexOf($plot_selected);
      if (plot_index >= 0) {
        $plot_page = Math.floor(plot_index / plot_page_size);
      }
    }
    if (plot_seqs.length % plot_page_size === 0) {
      max_plot_page = plot_seqs.length / plot_page_size - 1;
    } else {
      max_plot_page = Math.floor(plot_seqs.length / plot_page_size);
    }
    if ($plot_page > max_plot_page) {
      $plot_page = max_plot_page;
    }
    return plot_seqs.slice($plot_page * plot_page_size, ($plot_page + 1) * plot_page_size);
  }
  function goto_first_page() {
    if ($plot_page > 0) {
      if ($plot_selected) {
        $plot_selected = '';
      }
      $plot_page = 0;
    }
  }
  function goto_last_page() {
    if ($plot_page < max_plot_page) {
      if ($plot_selected) {
        $plot_selected = '';
      }
      $plot_page = max_plot_page;
    }
  }
  function goto_next_page() {
    if ($plot_page < max_plot_page) {
      if ($plot_selected) {
        $plot_selected = '';
      }
      $plot_page = $plot_page + 1;
    }
  }
  function goto_prev_page() {
    if ($plot_page > 0) {
      if ($plot_selected) {
        $plot_selected = '';
      }
      $plot_page = $plot_page - 1;
    }
  }  
  function window_resize() {
    if (window.innerWidth < 800) {
      plot_page_size = Math.max(1, Math.floor((window.innerHeight - 300) / 50));
    } else {
      plot_page_size = Math.max(1, Math.floor((window.innerHeight - 220) / 50));
    }
    plots_shown = get_plots_shown();
  }
  
  afterUpdate(() => {
    if ($leaflet_map) {
      $leaflet_map.invalidateSize(false);
    }
  });
  
  onMount(async () => {
    window_resize();
  });
  
  const components = {
    bookmarks: BookmarkItem,
    layers: LayerItem,
    plots: PlotItem,
    profile: ProfileItem,
  };
  $: items = {
    bookmarks: $bookmarks,
    layers: $leaflet_layers,
    plots: $plots,
    profile: {'profile': true},
  };
  $: plots_shown = get_plots_shown($plots, $plot_selected, $plot_page);
  let plot_page_size = 20;
  let max_plot_page = 0;
</script>

<svelte:window on:resize={window_resize}/>

{#if $panel_selected && items[$panel_selected]}
  <section>
    <h1>{util.caption($lang,'nav_panel',$panel_selected)}</h1>
    <div class='items'>
      {#if $panel_selected === 'plots'}
        {#key plots_shown}
          {#each plots_shown as item_id}
            <svelte:component this={components[$panel_selected]} {item_id}/>
          {/each}
        {/key}
      {:else}
        {#key $bookmarks || $leaflet_layers}
          {#each Object.keys(items[$panel_selected]).sort() as item_id}
            <svelte:component this={components[$panel_selected]} {item_id}/>
          {/each}
        {/key}
      {/if}
    </div>
    {#if $panel_selected === 'plots'}
      {#key $plot_page}
        <div class='filler-vertical'></div>
        <div class='pagination'>
          {#if $plot_page === 0}
            <button disabled>{util.caption($lang,'pagination','first_page')}</button>
            <button disabled>{util.caption($lang,'pagination','prev_page')}</button>
          {:else}
            <button on:click={goto_first_page}>{util.caption($lang,'pagination','first_page')}</button>
            <button on:click={goto_prev_page}>{util.caption($lang,'pagination','prev_page')}</button>
          {/if}
          <div class='filler-horizontal'></div>
          <p>{util.caption($lang,'pagination','page_number')} {$plot_page + 1}</p>
          <div class='filler-horizontal'></div>
          {#if $plot_page === max_plot_page}
            <button disabled>{util.caption($lang,'pagination','next_page')}</button>
            <button disabled>{util.caption($lang,'pagination','last_page')}</button>
          {:else}
            <button on:click={goto_next_page}>{util.caption($lang,'pagination','next_page')}</button>
            <button on:click={goto_last_page}>{util.caption($lang,'pagination','last_page')}</button>
          {/if}
        </div>
      {/key}
    {/if}
    {#if config.panel_buttons[$panel_selected]}
      <div class='buttons'>
        {#each config.panel_buttons[$panel_selected] as button_id}
          <SideButton {button_id}/>
        {/each}
      </div>
    {/if}
  </section>
{/if}
